import { z } from "zod";
import { type HSL, hslZodSchema } from "./hsl-color";

type HSLA = HSL & { alpha: number };
const hslaZodSchema = hslZodSchema.and(
    z.object({
        alpha: z.number().min(0).max(1),
    }),
);
const partialHslaZodSchema = hslZodSchema.partial().and(
    z
        .object({
            alpha: z.number().min(0).max(1),
        })
        .partial(),
);

export { hslaZodSchema, partialHslaZodSchema };
export type { HSLA };
